import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import {
  VMSVendorInvoicesListRBAC,
  VMSVendorInvoiceReviewRBAC,
  VendorSKPInfoRBAC,
  ProductVendorsRBAC,
  ProductVendorsUpsertRBAC,
  VMSVendorListRBAC,
  VMSAddVendorRBAC,
  VendorBrandGroupRBAC,
  VMSAddPrincipalRBAC,
  VMSEditPrincipalRBAC,
  VMSDraftPrincipalRBAC,
  VMSPrincipalReviewRBAC,
  VMSVendorDetailsUpsertRBAC,
  VendorPortalAccountsRBAC,
} from './rbac'
import { VENDOR_INVOICE_REVIEW_PATH, VENDOR_INVOICE_SKU_MATCH_PATH } from './vendorInvoicePaths'

const VendorList = lazy(() => import('../pages/VendorList'))
const AddEditVendor = lazy(() => import('../pages/AddEditVendor'))
const VendorDataSKP = lazy(() => import('../pages/VendorDataSKP'))
const VendorInvoiceList = lazy(() => import('../pages/VendorInvoice/VendorInvoiceList'))
const VendorInvoiceReview = lazy(() => import('../pages/VendorInvoice/VendorInvoiceReview'))
const VendorInvoiceSkuMatch = lazy(() => import('../pages/VendorInvoice/VendorInvoiceSkuMatch'))
const PODetails = lazy(() => import('../pages/VendorInvoice/PODetails'))
const ProductVendors = lazy(() => import('../pages/ProductVendors'))
const ProductVendorsUpsert = lazy(() => import('../pages/ProductVendorUpsert'))
const PrincipalUpsert = lazy(() => import('../pages/PrincipalUpsert'))
const PrincipalReview = lazy(() => import('../pages/PrincipalReview'))
const VendorBrandGroup = lazy(() => import('../pages/VendorBrandGroup'))
const RegularVendor = lazy(() => import('../pages/RegularVendor'))
const VendorPortalAccounts = lazy(() => import('../pages/VendorPortalAccounts'))

export const vendorPath = 'dashboard/vendor'

export const VendorListRouter: RouterFeatureInterface<'VendorListRouter', '/dashboard/vendor'> = {
  name: 'VendorListRouter',
  Component: VendorList,
  path: '/dashboard/vendor',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorListRBAC.pageID,
}

export const VendorDetailsRouter: RouterFeatureInterface<
  'VendorDetailsRouter',
  '/dashboard/vendor/details/:id'
> = {
  name: 'VendorDetailsRouter',
  Component: RegularVendor,
  path: '/dashboard/vendor/details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorDetailsUpsertRBAC.pageID,
}

export const EditVendorRouter: RouterFeatureInterface<
  'EditVendorRouter',
  '/dashboard/vendor/edit-vendor/:id'
> = {
  name: 'EditVendorRouter',
  Component: RegularVendor,
  path: '/dashboard/vendor/edit-vendor/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorDetailsUpsertRBAC.pageID,
}

const AddVendorRouter: RouterFeatureInterface<
  'AddVendorRouter',
  '/dashboard/vendor/add-vendor/:type'
> = {
  name: 'AddVendorRouter',
  Component: AddEditVendor,
  path: '/dashboard/vendor/add-vendor/:type',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSAddVendorRBAC.pageID,
}

export const EditSubmissionDraftRouter: RouterFeatureInterface<
  'EditSubmissionDraftRouter',
  '/dashboard/vendor/edit-request-draft/:id'
> = {
  name: 'EditSubmissionDraftRouter',
  Component: AddEditVendor,
  path: '/dashboard/vendor/edit-request-draft/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: VMSAddVendorRBAC.pageID,
  isDashboard: true,
}

export const VendorDetailSKPDataRouter: RouterFeatureInterface<
  'VendorSKPDataRouter',
  '/dashboard/vendor/skp-data/:vendorId'
> = {
  name: 'VendorSKPDataRouter',
  Component: VendorDataSKP,
  path: '/dashboard/vendor/skp-data/:vendorId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VendorSKPInfoRBAC.pageID,
}

export const VendorInvoiceListRouter: RouterFeatureInterface<
  'VendorInvoiceListRouter',
  '/dashboard/vendor/vendor-invoice'
> = {
  name: 'VendorInvoiceListRouter',
  Component: VendorInvoiceList,
  path: '/dashboard/vendor/vendor-invoice',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorInvoicesListRBAC.pageID,
}

export const VendorInvoiceHistoryRouter: RouterFeatureInterface<
  'VendorInvoiceHistoryRouter',
  '/dashboard/vendor/vendor-invoice-history'
> = {
  name: 'VendorInvoiceHistoryRouter',
  Component: VendorInvoiceList,
  path: '/dashboard/vendor/vendor-invoice-history',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorInvoicesListRBAC.pageID,
}

export const VendorInvoiceReviewRouter: RouterFeatureInterface<
  'VendorInvoiceReviewRouter',
  typeof VENDOR_INVOICE_REVIEW_PATH
> = {
  name: 'VendorInvoiceReviewRouter',
  Component: VendorInvoiceReview,
  path: VENDOR_INVOICE_REVIEW_PATH,
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorInvoiceReviewRBAC.pageID,
}

export const VendorInvoiceSkuMatchRouter: RouterFeatureInterface<
  'VendorInvoiceSkuMatchRouter',
  typeof VENDOR_INVOICE_SKU_MATCH_PATH
> = {
  name: 'VendorInvoiceSkuMatchRouter',
  Component: VendorInvoiceSkuMatch,
  path: VENDOR_INVOICE_SKU_MATCH_PATH,
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSVendorInvoiceReviewRBAC.pageID,
}

export const PODetailsRouter: RouterFeatureInterface<
  'PODetailsRouter',
  '/dashboard/vendor/po-details/:poNumber'
> = {
  name: 'PODetailsRouter',
  Component: PODetails,
  path: '/dashboard/vendor/po-details/:poNumber',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
}

export const ProductVendorRouter: RouterFeatureInterface<
  'ProductVendorRouter',
  '/dashboard/vendor/product-vendors/:id'
> = {
  name: 'ProductVendorRouter',
  Component: ProductVendors,
  path: '/dashboard/vendor/product-vendors/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ProductVendorsRBAC.pageID,
}

export const ProductVendorAddRouter: RouterFeatureInterface<
  'ProductVendorAddRouter',
  '/dashboard/vendor/product-vendors/:id/add'
> = {
  name: 'ProductVendorAddRouter',
  Component: ProductVendorsUpsert,
  path: '/dashboard/vendor/product-vendors/:id/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ProductVendorsUpsertRBAC.pageID,
}

export const ProductVendorEditRouter: RouterFeatureInterface<
  'ProductVendorEditRouter',
  '/dashboard/vendor/product-vendors/:id/edit/:vendorId'
> = {
  name: 'ProductVendorEditRouter',
  Component: ProductVendorsUpsert,
  path: '/dashboard/vendor/product-vendors/:id/edit/:vendorId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ProductVendorsUpsertRBAC.pageID,
}

export const VendorBrandGroupRouter: RouterFeatureInterface<
  'VendorBrandGroupRouter',
  '/dashboard/vendor/vendor-brand-group'
> = {
  name: 'VendorBrandGroupRouter',
  Component: VendorBrandGroup,
  path: '/dashboard/vendor/vendor-brand-group',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VendorBrandGroupRBAC.pageID,
}

export const PrincipalReviewRouter: RouterFeatureInterface<
  'PrincipalReviewRouter',
  '/dashboard/vendor/principal-review/:id'
> = {
  name: 'PrincipalReviewRouter',
  Component: PrincipalReview,
  path: '/dashboard/vendor/principal-review/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSPrincipalReviewRBAC.pageID,
}

export const CreatePrincipalRouter: RouterFeatureInterface<
  'CreatePrincipalRouter',
  '/dashboard/vendor/create-principal'
> = {
  name: 'CreatePrincipalRouter',
  Component: PrincipalUpsert,
  path: '/dashboard/vendor/create-principal',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSAddPrincipalRBAC.pageID,
}

export const EditPrincipalRouter: RouterFeatureInterface<
  'EditPrincipalRouter',
  '/dashboard/vendor/edit-principal/:id'
> = {
  name: 'EditPrincipalRouter',
  Component: PrincipalUpsert,
  path: '/dashboard/vendor/edit-principal/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSEditPrincipalRBAC.pageID,
}

export const EditDraftPrincipalRouter: RouterFeatureInterface<
  'EditPrincipalRouter',
  '/dashboard/vendor/draft-principal/:id'
> = {
  name: 'EditPrincipalRouter',
  Component: PrincipalUpsert,
  path: '/dashboard/vendor/draft-principal/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VMSDraftPrincipalRBAC.pageID,
}

export const VendorPortalAccountsRouter: RouterFeatureInterface<
  'VendorPortalAccountsRouter',
  '/dashboard/vendor/vendor-portal-accounts/:id'
> = {
  name: 'VendorPortalAccountsRouter',
  Component: VendorPortalAccounts,
  path: '/dashboard/vendor/vendor-portal-accounts/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: VendorPortalAccountsRBAC.pageID,
}

const VendorsRouter = [
  VendorListRouter,
  VendorDetailsRouter,
  AddVendorRouter,
  EditVendorRouter,
  ProductVendorAddRouter,
  ProductVendorEditRouter,
  VendorDetailSKPDataRouter,
  VendorInvoiceListRouter,
  VendorInvoiceHistoryRouter,
  VendorInvoiceSkuMatchRouter,
  VendorInvoiceReviewRouter,
  PODetailsRouter,
  ProductVendorRouter,
  VendorBrandGroupRouter,
  PrincipalReviewRouter,
  CreatePrincipalRouter,
  EditPrincipalRouter,
  EditDraftPrincipalRouter,
  EditSubmissionDraftRouter,
  VendorPortalAccountsRouter,
]

export const VendorRouterDetail = generateRouterDetail(VendorsRouter)

export default VendorsRouter
